export default __webpack_public_path__ + "static/media/chip_delete.69640b32.svg";